
import { Component, RefObject } from "react";

import foxOrderActionCreator from "../../controller/action/FoxOrderActionCreator";
import Service from "../../controller/model/service/Service";
import FoxOrderStore from "../../controller/store/FoxOrderStore";

import { FoxOrderConnected } from "./FoxOrderConnected";
import FoxorderLogin from "./foxorderLogin";
import React from "react";
import { Shop } from "../../controller/api/FoxOrderApi";
import WithStyles from "../utils/WithStyles";

interface FoxOrderStateInterface {
    service: Service
    shops: Shop[]
    isReady: boolean
    showError: boolean
    showAlert: boolean
    showEstablishments: boolean
    alertSeverity: "success" | "info" | "warning" | "error"
    message: string | undefined
    isLoading: boolean;
    usernameRef: RefObject<HTMLInputElement>
    passwordRef: RefObject<HTMLInputElement>
}

const _updateState = (): any => {
    const serviceUser = FoxOrderStore;
    return {
        service: serviceUser.service,
        shops: serviceUser.shops
    };
};

class FoxorderContainer extends Component {
    public state: FoxOrderStateInterface;

    constructor(props: FoxOrderStateInterface) {
        super(props);
        this.state = {
            service: FoxOrderStore.service,
            shops: FoxOrderStore.shops,
            isReady: false,
            showError: false,
            showAlert: false,
            showEstablishments: false,
            alertSeverity: "info",
            message: "",
            isLoading: false,
            usernameRef: React.createRef<HTMLInputElement>(),
            passwordRef: React.createRef<HTMLInputElement>()
        };
        this._handleCloseSnackBar = this._handleCloseSnackBar.bind(this)
        this._handleTapLoginButton = this._handleTapLoginButton.bind(this)
    }

    _handleStateChange() {
        this.setState(_updateState());
    }

    componentDidMount(): void {
        foxOrderActionCreator.loadService().catch((err) => { console.error(err) })
        FoxOrderStore.addChangeListener(this._handleStateChange.bind(this));
        // foxOrderActionCreator.getAllActiveConnections()
    }

    _handleCloseSnackBar = () => {
        this.setState({ showError: false, message: "", showAlert: false });
    }

    _handleInputValidation(inputRef: RefObject<HTMLInputElement>, errorMessage: string): string | null {
        const inputValue = inputRef.current?.value

        if (!inputValue) {
            this.setState({ showError: true, message: errorMessage, alertSeverity: "error" })
            return null
        }
        return inputValue
    }

    _handleTapLoginButton = () => {
        const { usernameRef, passwordRef } = this.state

        const username = this._handleInputValidation(usernameRef, "Veuillez renseigner votre nom d'utilisateur")
        const password = this._handleInputValidation(passwordRef, "Veuillez renseigner votre mot de passe")

        if (username && password) {
            this.setState({ isLoading: true })
            foxOrderActionCreator.connectService(username, password, 0).then((response) => {
                if (typeof response === "string") {
                    this.setState({ showAlert: true, message: `${response}`, alertSeverity: "error", showError: true })
                }
                this.setState({ isLoading: false })
            }).catch((err) => {
                this.setState({ showAlert: true, message: `${err}`, alertSeverity: "error", showError: true })
                this.setState({ isLoading: false })
            })
        }
    }

    _handleShowEstablishments = (establishment: Shop) => {
        foxOrderActionCreator.selectEstablishment(establishment)
        this.setState({ showEstablishments: false })
    }

    _handleTapDisconnectButton = () => {
        this.setState({ isLoading: true })
        foxOrderActionCreator.disconnectFoxOrderService(this.state.service.accountId ?? "").then(() => {
            this.setState({ showAlert: true, message: "Déconnexion réussie", alertSeverity: "success" })
            this.setState({ isLoading: false })
        }).catch((error) => {
            this.setState({ isLoading: false })
            if (error instanceof Error) console.warn(error.message)
            this.setState({ showAlert: true, message: "Erreur lors de la déconnexion, veuillez réessayer", showError: true })
        })
    }

    renderLoginSection = () => {
        return (
            <StyledFoxOrderLogin
                _handleCloseSnackBar={this._handleCloseSnackBar}
                showError={this.state.showError}
                message={this.state.message}
                _handleTapLoginButton={this._handleTapLoginButton}
                isLoading={this.state.isLoading}
                usernameRef={this.state.usernameRef}
                passwordRef={this.state.passwordRef}
                showEstablishments={this.state.service.isActive === false && this.state.shops.length > 0}
                _handleShowEstablishments={this._handleShowEstablishments}
                shops={this.state.shops}
            />
        )
    }

    renderConnectedSection = () => {
        return (
            <StyledFoxOrderConnected
                _handleCloseSnackBar={this._handleCloseSnackBar}
                _handleTapDisconnectButton={this._handleTapDisconnectButton}
                alertSeverity={this.state.alertSeverity}
                message={this.state.message}
                showAlert={this.state.showAlert}
                service={this.state.service}
            />
        )
    }

    render() {
        return this.state.service.isActive ? this.renderConnectedSection() : this.renderLoginSection()
    }
}

export default FoxorderContainer
const StyledFoxOrderConnected = WithStyles(FoxOrderConnected)
const StyledFoxOrderLogin = WithStyles(FoxorderLogin)